<app-nav></app-nav>

<app-home-hero-for-buseness id="main"></app-home-hero-for-buseness>
<lib-main-theses [lang]="'uk'"></lib-main-theses>
<app-about-us-business id="about-us"></app-about-us-business>

<app-publications (loaded)="onPubLoaded()" id="publications"></app-publications>
<app-for-whoom [type]="'business'" id="for_whom"></app-for-whoom>

<!--<app-reviews></app-reviews>-->

<!--<app-plans [returnUrl]="'cs'" [successRoute]="'cs'" (loaded)="onPlansLoaded($event)"></app-plans>-->
<app-faq></app-faq>
<!--<app-not-supported-mobile class="mobile-block"></app-not-supported-mobile>-->
<app-footer></app-footer>
<lib-promo-handler [apiUrl]="apiUrl" [userData]="auth.userData"></lib-promo-handler>
<lib-promo-code-handler [apiUrl]="apiUrl" [userData]="auth.userData"></lib-promo-code-handler>
